/* La pestaña que parpadea cuando llega un mensaje (Igna, 23/10/2026).
 *
 * El mensaje interno no exige que los dos estén libres a la vez, pero sí que
 * el que recibe se entere. Con FiBOT abierto en otra pestaña —que es lo
 * normal: se trabaja en otra cosa— el mensaje llegaba y nadie lo veía hasta
 * volver a mirar. El título que alterna se ve desde la barra de pestañas.
 *
 * Acá vive sólo la regla, sin el navegador, para poder probarla:
 *   · qué mensajes cuentan (los que me escriben otros, no los míos);
 *   · qué dice el título que alterna;
 *   · cuándo NO se parpadea (la pestaña está a la vista y con foco).
 */

export const CADA_MS = 1000;

/* ¿Este mensaje es para avisarme? Sólo lo que me escribe otro: lo que mando
 * yo también entra por el mismo canal y no tiene que hacer nada. */
export function esParaAvisar(m, yo) {
  if (!m || !yo) return false;
  const para = String(m.para || "").toLowerCase();
  const de = String(m.de || "").toLowerCase();
  return para === yo && de !== yo;
}

/* Con la pestaña a la vista y con foco, la persona ya lo está viendo. */
export function hayQueParpadear({ oculta, conFoco }) {
  return Boolean(oculta || !conFoco);
}

const nombreCorto = (mail) => (String(mail || "").split("@")[0] || "").trim();

/* «(2) Mensaje de Nicolas Cantarini». Con más de una persona, el número
 * cuenta todos y el nombre es el del último que escribió. */
export function tituloAviso(cuantos, nombre, mail) {
  const quien = (nombre || "").trim() || nombreCorto(mail) || "un compañero";
  return `(${cuantos}) Mensaje de ${quien}`;
}
